<template>
  <div class="font-sans antialiased text-slate-900">
    <header
      class="hidden lg:flex items-center justify-between px-10 py-2 bg-[#0a0a33] text-white fixed top-0 left-0 w-full z-[60] text-[11px] xl:text-xs"
      data-aos="fade-down">
      
      <div class="flex items-center gap-6">
        <div class="flex items-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-blue-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
          </svg>
          <span class="hover:text-blue-300 transition cursor-default"><b>Bafoussam:</b> +237 656 53 12 25</span>
          <span class="text-gray-600">|</span>
          <span class="hover:text-blue-300 transition cursor-default"><b>Dschang:</b> +237 695 63 20 89</span>
        </div>

        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-blue-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
          </svg>
          <span class="hover:text-blue-300 transition">novalinguabafoussam@gmail.com</span>
        </div>
      </div>

      <div class="hidden xl:flex items-center gap-2 flex-1 justify-center max-w-2xl px-4 italic text-gray-300">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-blue-400 flex-shrink-0">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
        </svg>
        <span class="truncate"><b>Bafoussam:</b> Marché d'entrée (Collège Pointe) — <b>Dschang:</b> En Face de l'entree de la chefferie Foto, dans l'immeuble abritant la boulangerie la paix et  la pharmacie de l'unite au 2eme etage</span>
      </div>

      <div class="flex items-center gap-3">
        <a href="https://www.facebook.com/share/18qPBsXDeB/?mibextid=wwXIfr" target="_blank" class="hover:opacity-80 transition">
          <img :src="require('@/assets/icons/facebook.png')" alt="fb" class="w-4 h-4 invert" />
        </a>
        <a href="https://www.instagram.com/novalinguabafoussam?igsh=MWQ5dng3ZG5xbXp2Yw==" target="_blank" class="hover:opacity-80 transition">
          <img :src="require('@/assets/icons/instagram.png')" alt="ig" class="w-4 h-4 invert" />
        </a>
      </div>
    </header>

    <nav
      class="fixed top-0 lg:top-[36px] left-0 w-full flex items-center justify-between px-6 md:px-12 py-4 bg-white/80 backdrop-blur-xl border-b border-gray-200/50 z-50 transition-all"
      data-aos="fade-up">
      <router-link to="/" class="flex items-center space-x-2 active:scale-95 transition-transform">
        <img :src="require('@/assets/images/novalingua.png')" alt="logo" class="w-10 h-10 object-contain shadow-sm rounded-lg" />
        <h1 class="text-blue-700 font-bold text-xl tracking-tight">NovaLingua</h1>
      </router-link>

      <div class="hidden md:flex gap-10 items-center">
        <router-link v-for="link in links" :key="link.name" :to="link.to"
          class="text-slate-600 hover:text-blue-700 font-medium text-[14px] uppercase tracking-wider transition-colors">
          {{ link.name }}
        </router-link>
      </div>

      <div class="flex items-center gap-4">
        <button @click="contact" class="bg-blue-700 hidden md:block text-white font-semibold px-7 py-2.5 rounded-full hover:bg-blue-800 transition-all shadow-md active:scale-95">
          Contactez-nous
        </button>

        <button @click="isMenuOpen = !isMenuOpen" class="md:hidden p-2 text-blue-700">
          <svg v-if="!isMenuOpen" xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 8h16M4 16h16" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </nav>

    <transition name="apple-menu">
      <div v-if="isMenuOpen" class="fixed inset-0 z-[100] bg-white/95 backdrop-blur-2xl flex flex-col p-8 md:hidden">
        <button @click="isMenuOpen = false" class="self-end p-2 mb-10 text-blue-700 bg-gray-100 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <div class="flex flex-col space-y-6">
          <router-link v-for="link in links" :key="link.name" :to="link.to" 
            class="text-4xl text-blue-700 font-bold tracking-tighter active:opacity-50 transition-opacity"
            @click="isMenuOpen = false">
            {{ link.name }}
          </router-link>
        </div>

        <div class="mt-auto">
          <button class="w-full bg-blue-700 text-white py-5 rounded-3xl text-xl font-bold shadow-xl active:scale-95 transition-transform mb-8"
            @click="contact(); isMenuOpen = false">
            Contactez-nous
          </button>
          
          <div class="space-y-2 text-center text-slate-500 font-medium pb-6 border-t pt-6 border-gray-100">
            <p class="flex items-center justify-center gap-2">
               <span class="w-1.5 h-1.5 bg-blue-400 rounded-full"></span> Bafoussam: +237 656 53 12 25
            </p>
            <p class="flex items-center justify-center gap-2">
               <span class="w-1.5 h-1.5 bg-blue-400 rounded-full"></span> Dschang: +237 695 63 20 89
            </p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const isMenuOpen = ref(false);

const links = [
  { name: "accueil", to: "/" },
  { name: "apropos", to: "/apropos" },
  { name: "services", to: "/services" },
  { name: "formations", to: "/formations" },
  { name: "partenaires", to: "/partenaires" },
];

function contact() {
  router.push({ name: 'ContactView' });
}
</script>

<style scoped>
/* Animation de menu iOS */
.apple-menu-enter-active,
.apple-menu-leave-active {
  transition: transform 0.6s cubic-bezier(0.32, 0.72, 0, 1), opacity 0.4s;
}

.apple-menu-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.apple-menu-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

/* Style de lien actif avec petite barre sous le texte */
.router-link-active {
  color: #1d4ed8;
  position: relative;
}

.router-link-active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1d4ed8;
  border-radius: 2px;
}

.invert {
  filter: brightness(0) invert(1);
}
</style>